import { useMemo } from 'react';
import { itemSchedulingFilterByTab } from '../../_lib/lib';
import { IItemSchedulingTab } from '../../types/IItemSetup';
import { getItemSchedulingTabStats } from './Utils';

export const useItemSchedulingTabItems = (items: any[] | null, tab: IItemSchedulingTab) => {
  const currentTabItems = useMemo(
    () => (items ?? []).filter((item: any) => itemSchedulingFilterByTab(tab, item)),
    [items, tab]
  );

  const tabStats = useMemo(() => getItemSchedulingTabStats(items), [items]);

  return { currentTabItems, tabStats };
};

export default useItemSchedulingTabItems;
